import {ReactNode} from 'react';
import styled from 'styled-components';

import {Handler} from '../../../../../../libs/shared/helpers/src/react/reactHelpers';
import {ButtonVariantsEnum} from '../../../../../../libs/shared/ui/src/components/buttons/buttonConstants';
import {VisualSizesEnum} from '../../../../../../libs/shared/ui/src/styles/commonStyles';
import {fontSizes, fontWeights} from '../../../../../../libs/shared/ui/src/styles/fontStyles';
import {InboxModel} from '../../../../../models/api/inboxModel';
import {IntegrationIconsEnum} from '../../../../common/integrationIcon';

/*
 * Constants.
 */

export enum CellsEmptySetupActionsVariantsEnum {
  TEAMMATE = 'teammate',
  TEAM = 'team',
  TEAMMATES = 'teammates',
}

export interface CellsEmptySetupActionsDefinition {
  title: ReactNode;
  onClick: Handler;
  interactionId: string;
  buttonVariant?: ButtonVariantsEnum;
  integrationIcon?: IntegrationIconsEnum;
  spacingSize?: VisualSizesEnum;
}

export interface CellsEmptySetupActionsProps {
  type: CellsEmptySetupActionsVariantsEnum;
  navigate: (destination: string) => Handler;
  onDismissClick: Handler;
  namespace?: string;
  /** The currently selected demo inbox (optional). Included only if we've selected a single demo inbox workspace in P1. */
  selectedTeamDemoInbox?: InboxModel;
}

/*
 * Style.
 */

export const StyledEmptyDiv = styled.div`
  grid-row: 1 / span 3;
  grid-column: 1;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const StyledCellsEmptySetupActionsWrapperDiv = styled.div`
  display: grid;
  grid-template-rows: auto 20px;
  grid-template-areas:
    'content'
    'footer';
  padding: 20px;
`;

export const StyledCellsEmptySetupActionsContentDiv = styled.div`
  grid-area: content;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const StyledCellsEmptySetupActionsTitleDiv = styled.div`
  font-size: ${fontSizes.large};
  font-weight: ${fontWeights.semibold};
  letter-spacing: -0.15px;
  line-height: 20px;
  color: ${(p) => p.theme.greys.shade90};
  margin-bottom: 6px;
`;

export const StyledCellsEmptySetupActionsSubTitleDiv = styled.div`
  font-size: ${fontSizes.medium};
  font-weight: ${fontWeights.normal};
  letter-spacing: -0.0015em;
  line-height: 24px;
  color: ${(p) => p.theme.greys.shade80};
  margin-bottom: 24px;
  text-align: center;
`;

export const StyledNoResultsDiv = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
